import { defineStore } from 'pinia'

interface State {
  hasConsentedCookies: boolean
  languageCookie: ILocale
  countryCookie: string
}

export const useCookieStore = defineStore('cookies', {
  state: (): State => ({
    hasConsentedCookies: false, // this is used and updated only on client side
    languageCookie: 'en',
    countryCookie: '',
  }),
})
